<template>
  <div>
    <el-card style="margin-bottom: 20px">
      <el-form :model="query" inline>
        <el-form-item label="关键词">
          <el-input
            v-model="query.word"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card>
      <div style="margin-bottom: 15px">
        <el-button type="primary" @click="handleAdd">新增</el-button>
        <el-button @click="handleImport">批量导入</el-button>
        <el-button
          @click="
            hitRecordsVisible = true;
            fetchHitRecords();
          "
          >命中记录</el-button
        >
      </div>
      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="word" label="关键词"></el-table-column>
        <el-table-column prop="wordType" label="类型">
          <template slot-scope="{ row }">
            <el-tag size="small">{{ row.wordType || "其他" }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleEdit(row)">编辑</el-button>
            <el-button
              type="text"
              style="color: #f56c6c"
              @click="handleDelete(row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 20px; text-align: right"
        :current-page="query.page"
        :page-sizes="[10, 20, 50]"
        :page-size="query.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next"
        @size-change="
          (val) => {
            query.pageSize = val;
            fetchList();
          }
        "
        @current-change="
          (val) => {
            query.page = val;
            fetchList();
          }
        "
      ></el-pagination>
    </el-card>

    <el-dialog title="新增/编辑" :visible.sync="dialogVisible" width="450px">
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="关键词" prop="word">
          <el-input v-model="form.word"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="wordType">
          <el-select
            v-model="form.wordType"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option label="违法" value="违法"></el-option>
            <el-option label="色情" value="色情"></el-option>
            <el-option label="诈骗" value="诈骗"></el-option>
            <el-option label="引流" value="引流"></el-option>
            <el-option label="联系方式" value="联系方式"></el-option>
            <el-option label="广告" value="广告"></el-option>
            <el-option label="辱骂" value="辱骂"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>

    <!-- 命中记录弹窗 -->
    <el-dialog title="命中记录" :visible.sync="hitRecordsVisible" width="700px">
      <el-table :data="hitRecords" border size="small">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column
          prop="word"
          label="命中词"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="content"
          label="内容"
          min-width="200"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="时间"
          width="160"
        ></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  getViolationWords,
  addViolationWord,
  updateViolationWord,
  deleteViolationWord,
  importViolationWords,
  getHitRecords,
} from "../../api";

export default {
  name: "ViolationWordManage",
  data() {
    return {
      query: { word: "", page: 1, pageSize: 10 },
      list: [],
      total: 0,
      loading: false,
      dialogVisible: false,
      form: { id: null, word: "", wordType: "其他" },
      rules: {
        word: [{ required: true, message: "请输入关键词", trigger: "blur" }],
        wordType: [
          { required: true, message: "请选择类型", trigger: "change" },
        ],
      },
      hitRecordsVisible: false,
      hitRecords: [],
    };
  },
  created() {
    this.fetchList();
  },
  methods: {
    fetchList() {
      this.loading = true;
      getViolationWords(this.query)
        .then((res) => {
          this.list = res.data.records || res.data || [];
          this.total = res.data.total || 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fetchHitRecords() {
      getHitRecords().then((res) => {
        this.hitRecords = res.data.records || res.data || [];
      });
    },
    search() {
      this.query.page = 1;
      this.fetchList();
    },
    reset() {
      this.query = { word: "", page: 1, pageSize: 10 };
      this.fetchList();
    },
    handleAdd() {
      this.form = { id: null, word: "", wordType: "其他" };
      this.dialogVisible = true;
    },
    handleEdit(row) {
      this.form = { ...row };
      this.dialogVisible = true;
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        const fn = this.form.id
          ? updateViolationWord(this.form.id, this.form)
          : addViolationWord(this.form);
        fn.then(() => {
          this.$message.success("操作成功");
          this.dialogVisible = false;
          this.fetchList();
        });
      });
    },
    handleDelete(row) {
      this.$confirm("确定要删除该关键词吗？", "提示", { type: "warning" })
        .then(() => {
          deleteViolationWord(row.id).then(() => {
            this.$message.success("已删除");
            this.fetchList();
          });
        })
        .catch(() => {});
    },
    handleImport() {
      this.$prompt("请输入要导入的关键词，多个用逗号分隔", "批量导入")
        .then(({ value }) => {
          importViolationWords({
            words: value
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean),
          }).then(() => {
            this.$message.success("导入成功");
            this.fetchList();
          });
        })
        .catch(() => {});
    },
  },
};
</script>
